const dom = require('../utils/DOM');

function IssuePage() {
	if (dom.$body.hasClass('single-issue')) {
		this.init();
	}
}

IssuePage.prototype = {
	init: function() {
		this.$container = $('#primary');
		this.$shareIssueBtn = this.$container.find('.share-issue-btn-js');
		this.$closeShareBlock = this.$container.find('.close-share-block-js');
		this.$shareBlock = this.$container.find('.share-block');
		this.$issueBlock = this.$container.find('.issue-magazine');
		this.$shareIssueBtn.click(e => {
			e.preventDefault();
			this.openShare();
		});
		this.$closeShareBlock.click(e => {
			e.preventDefault();
			this.closeShare();
		});
	},
	openShare: function() {
		this.$shareBlock.addClass('flex-block').fadeIn();
		this.$issueBlock.css({
			height: '100vh',
			filter: 'blur(2px)',
		});
	},
	closeShare: function() {
		this.$shareBlock.fadeOut().removeClass('flex-block');
		this.$issueBlock.attr('style', '');
	},
};

module.exports = new IssuePage();
